import { createSelector } from 'reselect';

const selectPackage = (state) => state.package;

const selectV2Packages = createSelector(selectPackage, (p) => p?.v2_packages);

const selectV1Packages = createSelector(selectPackage, (p) => p?.v1_packages);

const selectUpdatedStatus = createSelector(
	selectPackage,
	(p) => p?.updatedStatus
);

const selectCreatedPackage = createSelector(selectPackage, (p) => p?.create);

const selectUpdatedPackage = createSelector(selectPackage, (p) => p?.update);

const packageSelectors = {
	selectPackage,
	selectV2Packages,
	selectV1Packages,
	selectUpdatedStatus,
	selectCreatedPackage,
	selectUpdatedPackage,
};

export default packageSelectors;
